const useInputColorColors = () => {
    const colors = [
        '#000000',
        '#FFFFFF',
        '#DDDDDD',
        '#BA435D',
        '#43BAA5',
        '#8F9BA4',
        '#edb124',
        '#f56f00',
        '#965eeb',
        '#3f47b5'
    ]
    return { colors }
}
export default useInputColorColors